import React from 'react';
import { Breadcrumb } from '@noths/polaris-client-next-components';

import * as styles from '../styles';
import { BreadcrumbWrapperProps } from '../types';

export const BreadcrumbWrapper = ({ onLinkClick, ...restOfProps }: BreadcrumbWrapperProps) => {
  return (
    <div css={styles.breadcrumbWrapper}>
      <Breadcrumb
        {...restOfProps}
        onBreadcrumbLinkClick={(e, { linkDepth }) => {
          e.preventDefault();
          const destinationUrl = e.currentTarget.href;
          onLinkClick?.({ linkDepth, destinationUrl }).then(() => {
            window.location.assign(destinationUrl);
          });
        }}
      />
    </div>
  );
};
